import request from '@/utils/request'

// 字典类型
export function getDictTypeList(data) {
  return request({ url: '/admin/dict/typeList', method: 'post', data })
}

export function createDictType(data) {
  return request({ url: '/admin/dict/typeCreate', method: 'post', data })
}

export function updateDictType(data) {
  return request({ url: '/admin/dict/typeUpdate', method: 'post', data })
}

export function deleteDictType(data) {
  return request({ url: '/admin/dict/typeDelete', method: 'post', data })
}

// 字典项
export function getDictItemList(data) {
  return request({ url: '/admin/dict/itemList', method: 'post', data })
}

export function createDictItem(data) {
  return request({ url: '/admin/dict/itemCreate', method: 'post', data })
}

export function updateDictItem(data) {
  return request({ url: '/admin/dict/itemUpdate', method: 'post', data })
}

export function deleteDictItem(data) {
  return request({ url: '/admin/dict/itemDelete', method: 'post', data })
}

export function getDictOptions(code) {
  return request({ url: '/admin/dict/options', method: 'post', data: { code } })
}
